/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_uc_data_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why does my 1TB hard drive show less than 1TB of space?`)
};

const es_uc_data_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Por qué mi unidad de disco duro de 1TB muestra menos de 1TB de espacio?`)
};

const de_uc_data_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warum zeigt meine 1-TB-Festplatte weniger als 1 TB Speicherplatz an?`)
};

const nl_uc_data_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waarom toont mijn 1TB harde schijf minder dan 1TB ruimte?`)
};

const fr_uc_data_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pourquoi mon disque dur de 1TB affiche-t-il moins de 1TB d'espace ?`)
};

const it_uc_data_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perché il mio disco rigido da 1TB mostra meno di 1TB di spazio?`)
};

const pt_br2_uc_data_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por que meu disco rígido de 1TB mostra menos de 1TB de espaço?`)
};

const pt_uc_data_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porque é que a minha unidade de disco 1TB mostra menos de 1TB de espaço?`)
};

const ja_uc_data_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1TB ハードドライブが1TB 未満のスペースを表示しないのはなぜですか?`)
};

const zh_uc_data_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[pending translation B]`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const uc_data_faq1_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.uc_data_faq1_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("uc_data_faq1_q", locale)
	if (locale === "en") return en_uc_data_faq1_q(inputs)
	if (locale === "es") return es_uc_data_faq1_q(inputs)
	if (locale === "de") return de_uc_data_faq1_q(inputs)
	if (locale === "nl") return nl_uc_data_faq1_q(inputs)
	if (locale === "fr") return fr_uc_data_faq1_q(inputs)
	if (locale === "it") return it_uc_data_faq1_q(inputs)
	if (locale === "pt-BR") return pt_br2_uc_data_faq1_q(inputs)
	if (locale === "pt") return pt_uc_data_faq1_q(inputs)
	if (locale === "ja") return ja_uc_data_faq1_q(inputs)
	return zh_uc_data_faq1_q(inputs)
};